import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_ORGANIZATIONS,
  CREATE_ORGANIZATIONS,
  DELETE_ORGANIZATIONS,
  UPDATE_ORGANIZATIONS,
} from './actionType';

import {
  OrganizationsApiResponseSuccess,
  OrganizationsApiResponseError,
} from './action';

import {
  getOrganizations as OrganizationsGet,
  createOrganizations as OrganizationsCreate,
  updateOrganizations as OrganizationsUpdate,
  deleteOrganizations as OrganizationsDelete,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getOrganizations(data) {
  try {
    const response = yield call(OrganizationsGet, data.payload.id);
    yield put(OrganizationsApiResponseSuccess(GET_ORGANIZATIONS, response));
  } catch (error) {
    yield put(OrganizationsApiResponseError(GET_ORGANIZATIONS, error));
  }
}

function* createOrganizations({ payload }) {
  const { data, history } = payload;

  try {
    const response = yield call(OrganizationsCreate, data);
    yield put(OrganizationsApiResponseSuccess(CREATE_ORGANIZATIONS, response));
    notifySuccess('Organização criada com sucesso!');
    history.goBack();
  } catch (error) {
    yield put(OrganizationsApiResponseError(CREATE_ORGANIZATIONS, error));
    notifyError('Erro ao criar organização!');
  }
}

function* updateOrganizations({ payload }) {
  const { history, ...data } = payload;

  try {
    const response = yield call(OrganizationsUpdate, data);
    yield put(OrganizationsApiResponseSuccess(UPDATE_ORGANIZATIONS, response));
    notifySuccess('Organização atualizada com sucesso!');
    history.goBack();
  } catch (error) {
    yield put(OrganizationsApiResponseError(UPDATE_ORGANIZATIONS, error));
    notifyError('Erro ao atualizar organização!');
  }
}

function* deleteOrganizations(data) {
  const { id } = data.payload;
  try {
    const response = yield call(OrganizationsDelete, id);
    yield put(OrganizationsApiResponseSuccess(DELETE_ORGANIZATIONS, response));
    notifySuccess('Organização deletada com sucesso!');
  } catch (error) {
    yield put(OrganizationsApiResponseError(DELETE_ORGANIZATIONS, error));
    notifyError('Erro ao deletar organização!');
  }
}

export function* watchGetOrganizations() {
  yield takeEvery(GET_ORGANIZATIONS, getOrganizations);
}

export function* watchCreateOrganizations() {
  yield takeEvery(CREATE_ORGANIZATIONS, createOrganizations);
}

export function* watchUpdateOrganizations() {
  yield takeEvery(UPDATE_ORGANIZATIONS, updateOrganizations);
}

export function* watchDeleteOrganizations() {
  yield takeEvery(DELETE_ORGANIZATIONS, deleteOrganizations);
}

function* OrganizationsSaga() {
  yield all([fork(watchGetOrganizations)]);
  yield all([fork(watchCreateOrganizations)]);
  yield all([fork(watchUpdateOrganizations)]);
  yield all([fork(watchDeleteOrganizations)]);
}

export default OrganizationsSaga;
